import * as React from 'react';

import moment from 'moment';
import PropTypes from 'prop-types';

import { Link } from '@coursera/cds-core';
import { ExternalLinkIcon } from '@coursera/cds-icons';

import { buildUrl } from 'bundles/discussions/utils/discussionsUrl';

import _t from 'i18n!nls/discussions';

class CreatedTimeLink extends React.Component {
  static propTypes = {
    post: PropTypes.object.isRequired,
    forumLink: PropTypes.string,
    isClickable: PropTypes.bool,
  };

  static defaultProps = {
    isClickable: true,
  };

  render() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'post' does not exist on type 'Readonly<{... Remove this comment to see the full error message
    const { post, forumLink, isClickable } = this.props;

    const postUrl = buildUrl(forumLink, post.questionId, post.topLevelForumAnswerId, post.forumCommentId);

    const createdTimeString = moment(new Date(post.createdAt)).fromNow();

    if (isClickable) {
      return (
        <Link
          href={postUrl}
          variant="standard"
          target="_blank"
          rel="noopener noreferrer"
          className="rc-CreatedTimeLink caption-text"
          aria-label={_t('#{createdTimeString}, opens in a new tab', {
            createdTimeString,
          })}
        >
          {createdTimeString} <ExternalLinkIcon size="small" />
        </Link>
      );
    } else {
      return <span className="rc-CreatedTimeLink dim caption-text">{createdTimeString}</span>;
    }
  }
}

export default CreatedTimeLink;
